<template>
    <main-content>
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#sent_files" role="tab" aria-selected="false">
                                {{ $t('settlement.sent_files') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#received_files" role="tab" aria-selected="false">
                                {{ $t('settlement.received_files') }}
                            </a>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
            </kt-panel-header>
            <kt-panel-body>
                <div class="tab-content">
                    <div class="tab-pane active" id="sent_files">
                        <kt-row class="text-center">
                            <kt-col v-bind:key="index"
                                    v-for="(data, index) in files.sent"
                                    xs="12" md="3"
                            >
                                <a class="btn btn-wide btn-outline-dark mb-1" v-bind:href="data.url">
                                    <i class="fa fa-file-code" aria-hidden="true"></i> {{ data.date }}
                                </a>
                            </kt-col>
                        </kt-row>
                    </div>
                    <div class="tab-pane" id="received_files">
                        <kt-row class="text-center">
                            <kt-col v-bind:key="index"
                                    v-for="(data, index) in files.received"
                                    xs="12" md="3"
                            >
                                <a class="btn btn-wide btn-outline-dark mb-1" v-bind:href="data.url">
                                    <i class="fa fa-file-code" aria-hidden="true"></i> {{ data.date }}
                                </a>
                            </kt-col>
                        </kt-row>
                    </div>
                </div>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import { mapGetters } from "vuex";

    export default {
        components: {
            mainContent,
        },
        mounted() {
            this.$store.dispatch('settlement/fetchFiles')
        },
        computed: {
            ...mapGetters('settlement', [
                'files'
            ])
        }
    }
</script>

<style scoped>

</style>